
        import i18n from 'i18n';
        import flattenObject from 'util/flattenObject';
    
            import nsa68f37aded0bf773e3a432d8c82c4f5den from './en.yaml'
            i18n.addResourceBundle('en', 'a68f37aded0bf773e3a432d8c82c4f5d', flattenObject(nsa68f37aded0bf773e3a432d8c82c4f5den), true, true);
        
        export default 'a68f37aded0bf773e3a432d8c82c4f5d';
    